import {
  AggressorFlagEnum,
  InlineFormattedNumber,
  MarketDataCardSide,
  PricingMode,
  SideEnum,
  format,
  useCurrency,
  type Security,
} from '@talos/kyoko';
import type { ClickToTradePreviewOrder } from './types';

interface ClickToTradeOrderPreviewProps {
  clickToTradePreviewOrder: ClickToTradePreviewOrder;
  security: Security;
}

export const ClickToTradeOrderPreview = ({ clickToTradePreviewOrder, security }: ClickToTradeOrderPreviewProps) => {
  // Default increment to 1 for contracts
  const { DefaultIncrement } = useCurrency(clickToTradePreviewOrder?.orderCurrency) || { DefaultIncrement: '1' };

  if (!security || !clickToTradePreviewOrder) {
    return null;
  }
  const { side, orderQty, price, intent, orderCurrency, pricingMode } = clickToTradePreviewOrder;

  const qty = format(orderQty, { spec: DefaultIncrement });
  const priceCurrency = pricingMode === PricingMode.BPS ? 'BPS' : security.QuoteCurrency;

  const displaySide =
    side === SideEnum.Buy
      ? intent === AggressorFlagEnum.Active
        ? 'Buy'
        : 'Bid'
      : intent === AggressorFlagEnum.Active
        ? 'Sell'
        : 'Offer';

  return (
    <div data-testid="click-to-trade-preview-order">
      <MarketDataCardSide side={side}>{displaySide}</MarketDataCardSide>{' '}
      <InlineFormattedNumber number={qty} currency={orderCurrency} /> @{' '}
      <InlineFormattedNumber number={price} currency={priceCurrency} />
    </div>
  );
};
